<section class="wrapper">
  <section mat-dialog-title>
    <button mat-dialog-close mat-icon-button matTooltip="Close.">
      <mat-icon>close</mat-icon>
    </button>
    <h1>
      <mat-icon>shopping_cart</mat-icon>
      {{ listingTitle }}
      @if (loading) {
        <mat-icon class="loading">autorenew</mat-icon>
      }
    </h1>
  </section>
  <section mat-dialog-content>
    @if (!loading && hasProducts) {
      <mat-table #table [dataSource]="data">
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef class="title"><p>Title</p></th>
          <td mat-cell *matCellDef="let row" class="title">{{ row.title }}</td>
        </ng-container>
        <ng-container matColumnDef="ticketsAvailable">
          <th mat-header-cell *matHeaderCellDef>Stock</th>
          <td mat-cell *matCellDef="let row">{{ row.ticketsAvailable }}</td>
        </ng-container>
        <ng-container matColumnDef="ticketsSold">
          <th mat-header-cell *matHeaderCellDef>Sold</th>
          <td mat-cell *matCellDef="let row">{{ row.ticketsSold }}</td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="actions"></th>
          <td mat-cell *matCellDef="let row">
            <mat-button-toggle-group>
              <button
                (click)="listOrders(row)"
                [disabled]="row.ticketsSold > 0 ? false: true"
                mat-icon-button
                matTooltip="Purchase list."
                >
                <mat-icon>list</mat-icon>
              </button>
              <button
                (click)="editProduct(row)"
                mat-icon-button
                matTooltip="Edit product."
                >
                <mat-icon>edit</mat-icon>
              </button>
              <button
                (click)="deleteItem(row)"
                mat-icon-button
                matTooltip="Delete product."
                >
                <mat-icon>delete</mat-icon>
              </button>
            </mat-button-toggle-group>
          </td>
        </ng-container>
      </mat-table>
    }
    @if (!loading && !hasProducts) {
      <mat-card class="no-results">
        <mat-card-content>
          <mat-icon>shopping_cart</mat-icon>
          No Products.
        </mat-card-content>
      </mat-card>
    }
  </section>
  <section align="end" mat-dialog-actions>
    <button
      (click)="editProduct()"
      mat-button
      matTooltip="Add product."
      type="button"
      >
      <mat-icon>add</mat-icon>
      Add Product
    </button>
  </section>
</section>
